import { LOCATION_INITIALIZED } from '@angular/common';
import { Injector } from '@angular/core';
import { Routes } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { AppConstants } from './AppConstants';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ConfigureTotpComponent } from './configure-totp/configure-totp.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ValidateEmailComponent } from './validate-email/validate-email.component';
import { ViewProfileComponent } from './view-profile/view-profile.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CanDeactivateGuardService } from './can-deactivate-guard.service';
import { LocaleService } from './locale.service';
import { LogoutComponent } from './logout/logout.component';
import { JoinComponent } from './join/join.component';
import { getAppBaseHref, HttpLoaderFactory, getLocale } from '../util/locationUtil';
import { BsSampleComponent } from './bs-sample/bs-sample.component';
import { NotWithSessionGuardService } from './not-with-session-guard.service';
import { NotWithoutSessionGuardService } from './not-without-session-guard.service';
import { HomeComponent } from './home/home.component';
const ɵ0 = { animation: 'Register' }, ɵ1 = { animation: 'ValidateEmail' }, ɵ2 = { animation: 'ForgotPassword' }, ɵ3 = { animation: 'ResetPassword' }, ɵ4 = { animation: 'Login' }, ɵ5 = { animation: 'Logout' }, ɵ6 = { animation: 'ViewProfile' }, ɵ7 = { animation: 'EditProfile' }, ɵ8 = { animation: 'ChangePassword' }, ɵ9 = { animation: 'ConfigureTotp' }, ɵ10 = { animation: 'Join' }, ɵ11 = { animation: 'Home' }, ɵ12 = { animation: 'NotFound' };
const appRoutes = [
    {
        path: AppConstants.ROUTE_REGISTER,
        component: RegisterComponent,
        canActivate: [NotWithSessionGuardService],
        data: ɵ0,
    },
    {
        path: AppConstants.ROUTE_VALIDATE_EMAIL,
        component: ValidateEmailComponent,
        data: ɵ1,
    },
    {
        path: AppConstants.ROUTE_FORGOT_PASSWORD,
        component: ForgotPasswordComponent,
        canActivate: [NotWithSessionGuardService],
        data: ɵ2,
    },
    {
        path: AppConstants.ROUTE_RESET_PASSWORD,
        component: LoginComponent,
        canActivate: [NotWithSessionGuardService],
        data: ɵ3,
    },
    {
        path: AppConstants.ROUTE_LOGIN,
        component: LoginComponent,
        runGuardsAndResolvers: 'always',
        canActivate: [NotWithSessionGuardService],
        data: ɵ4,
    },
    {
        path: AppConstants.ROUTE_LOGOUT,
        component: LogoutComponent,
        data: ɵ5,
    },
    {
        path: AppConstants.ROUTE_PROFILE,
        component: ViewProfileComponent,
        canActivate: [NotWithoutSessionGuardService],
        data: ɵ6,
    },
    {
        path: AppConstants.ROUTE_EDIT_PROFILE,
        component: EditProfileComponent,
        canActivate: [NotWithoutSessionGuardService],
        canDeactivate: [CanDeactivateGuardService],
        data: ɵ7,
    },
    {
        path: AppConstants.ROUTE_CHANGE_PASSWORD,
        component: ChangePasswordComponent,
        canActivate: [NotWithoutSessionGuardService],
        data: ɵ8,
    },
    {
        path: AppConstants.ROUTE_CONFIGURE_TOTP,
        component: ConfigureTotpComponent,
        canActivate: [NotWithoutSessionGuardService],
        data: ɵ9,
    },
    {
        path: AppConstants.ROUTE_JOIN,
        component: JoinComponent,
        data: ɵ10,
    },
    {
        path: AppConstants.ROUTE_HOME,
        component: HomeComponent,
        canActivate: [NotWithSessionGuardService, NotWithoutSessionGuardService],
        data: ɵ11,
    },
    {
        path: '**',
        component: PageNotFoundComponent,
        data: ɵ12,
    },
];
if (environment.production !== true) {
    appRoutes.unshift({
        path: AppConstants.ROUTE_BS_SAMPLE,
        component: BsSampleComponent,
        data: { animation: 'BS_SAMPLE' },
    });
}
export function appInitializerFactory(localeService, translate, injector) {
    return () => new Promise((resolve) => {
        // not sure what this is, docs say it "Indicates when a location is initialized."
        const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
        locationInitialized.then(() => {
            translate.setDefaultLang('en');
            const locale = getLocale();
            // check if any locale was requested
            if (locale) {
                localeService.setLocaleParam('locale');
                // try using requested locale
                translate.use(locale).subscribe(res => {
                    // success, all done.
                    localeService.setIsAvailable(true);
                    resolve(null);
                }, e => {
                    // requested locale not supported, check if language is available without the country part, if country part is found
                    if (locale.indexOf('-') > 0) {
                        translate.use(locale.split('-')[0]).subscribe(res => {
                            // success, all done.
                            localeService.setIsAvailable(true);
                            resolve(null);
                        }, err => {
                            // failed, locale not supported. Leave in path for future support and show notification
                            localeService.setIsAvailable(false);
                            resolve(null);
                        });
                    }
                    else {
                        // failed, locale not supported. Leave in path for future support and show notification
                        localeService.setIsAvailable(false);
                        resolve(null);
                    }
                });
            }
            else {
                // no locale was requested, continue with default.
                localeService.setLocaleParam(null);
                localeService.setIsAvailable(true);
                resolve(null);
            }
        });
    });
}
const ɵ13 = HttpLoaderFactory, ɵ14 = getAppBaseHref;
export class AppModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14 };
